<mat-checkbox
    color="primary"
    id="fieldMultiselect{{ field.ID }}"
    [(ngModel)]="dateSettings.allowTimeInput"
    (change)="updateAnswer()"
    [disabled]="showTimePickerLocked"
    >Show Time Picker</mat-checkbox
>
